"use client";

import { ArrowRight, Droplet, ShieldCheck, Zap, Waves } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Technology() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const features = [{
    index: "01",
    icon: ShieldCheck,
    title: "BEZSPOINOWA IZOLACJA",
    description: "Nasza technologia natryskowa tworzy jednolitą, bezszwową membranę, która całkowicie eliminuje ryzyko przecieków na łączeniach. Dzięki temu dach staje się monolityczną barierą, odporną na ekstremalne warunki atmosferyczne i zalegającą wodę."
  }, {
    index: "02",
    icon: Zap,
    title: "SZYBKA APLIKACJA",
    description: "Metoda natryskowa pozwala na błyskawiczne zabezpieczenie dużych powierzchni dachów przemysłowych i hal. Skracamy czas przestoju obiektu do minimum, zapewniając pełną ochronę bez konieczności kosztownego zrywania starego pokrycia papowego."
  }, {
    index: "03",
    icon: Droplet,
    title: "ODPORNOŚĆ NA UV",
    description: "Zastosowane powłoki poliuretanowe wykazują wyjątkową odporność na promieniowanie UV oraz wahania temperatur. Materiał zachowuje elastyczność przez lata, nie pęka i nie traci swoich właściwości hydroizolacyjnych nawet w pełnym słońcu."
  }, {
    index: "04",
    icon: Waves,
    title: "PEŁNA SZCZELNOŚĆ",
    description: "Hydroizolacja HydroRoof to gwarancja spokoju. Nasze membrany doskonale radzą sobie z uszczelnianiem trudnych detali dachowych, kominów, świetlików oraz obróbek blacharskich, tworząc trwałą barierę dla wilgoci w każdym zakamarku."
  }];
  return <section data-section-id="3113" id="technologia-bezspoinowa" className="bg-[#0b111b] text-foreground py-40 px-4 sm:px-6 lg:px-12 overflow-hidden relative">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`mb-24 lg:mb-32 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-mono text-xs sm:text-sm tracking-widest mb-6 uppercase" style={{
          color: "var(--primary)"
        }}>
            — HR-01.TECH
          </p>
          <h2 className="font-sans font-bold uppercase leading-[0.95] tracking-tighter !text-[rgba(234,237,240,1)] !text-6xl" style={{
          color: "var(--primary)"
        }}>TECHNOLOGIA BEZSPOINOWA</h2>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          const isOffset = i % 2 === 1;
          return <div key={i} data-index={i} className={`group relative transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"} ${isOffset ? "lg:mt-20" : ""}`} style={{
            transitionDelay: `${i * 120}ms`
          }}>
                {}
                <div className="absolute -inset-2 opacity-0 group-hover:opacity-100 blur-2xl transition-opacity duration-700 pointer-events-none" style={{
              background: "radial-gradient(circle at center, var(--primary), transparent 70%)"
            }} aria-hidden="true" />

                {}
                <div className="relative bg-card border border-border shadow-md p-8 sm:p-10 lg:p-12 h-full flex flex-col transition-all duration-500 rounded-lg">
                  {}
                  <div className="flex items-start justify-between mb-10">
                    <span className="font-mono text-sm tracking-widest" style={{
                  color: "var(--primary)"
                }}>
                      {feature.index}
                    </span>
                    <Icon className="w-10 h-10 stroke-1 transition-colors duration-500 text-foreground/70 group-hover:text-[var(--primary)]" strokeWidth={1} />
                  </div>

                  {}
                  <h3 className="font-default font-bold uppercase text-2xl sm:text-3xl lg:text-[2rem] leading-tight tracking-tight mb-6">
                    {feature.title}
                  </h3>

                  {}
                  <p className="font-sans text-base lg:text-lg leading-relaxed text-foreground/75 mb-10 flex-grow">
                    {feature.description}
                  </p>

                  {}
                  <div className="mt-auto">
                    <div className="h-px w-full mb-5 transition-all duration-500 bg-border" />
                    <Link to="/OurSolutionsPage" className="inline-flex items-center gap-2 font-mono text-xs tracking-widest uppercase text-foreground/60 group-hover:text-[var(--primary)] transition-colors duration-500">
                      DOWIEDZ SIĘ WIĘCEJ
                      <ArrowRight className="w-3.5 h-3.5 transition-transform duration-500 group-hover:translate-x-1" />
                    </Link>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {}
        <div ref={captionRef} className={`mt-24 lg:mt-32 text-center transition-all duration-1000 ease-out ${captionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-sans italic text-lg sm:text-xl lg:text-2xl text-foreground/60">
            HydroRoof – inżynieria ochrony Twojego dachu.
          </p>
        </div>
      </div>
    </section>;
}